import * as $ from 'jquery';
import { apiBaseUrlAdmin } from '../../../constants/url.constant';
import {
    ApproveOrderModel, ChangeWebsiteOrderModel, EditOrderModel,
    NewOrderModel, OrderFilterModel
} from "../models/OrderModel";

import { DefaultService } from "../../common/services/DefaultService";
import { EditProductModel } from '../../products/models/ProductModel';

export class OrderAdminService extends DefaultService {
    private baseUrl = `${apiBaseUrlAdmin}/order`;

    public RouteGetOpenList = (customerId: number) => `${this.baseUrl}/getOpenList/${customerId}`;
    public getOpenList(customerId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetOpenList(customerId), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGet = (id: number) => `${this.baseUrl}/get/${id}`;
    public get(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGet(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteSearch = () => `${this.baseUrl}/search`;
    public search(model: OrderFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteSearch(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetCountByStatus = () => `${this.baseUrl}/getCountByStatus`;
    public getCountByStatus(model: OrderFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteGetCountByStatus(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: NewOrderModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RoutePlaceOrder = (id: number) => `${this.baseUrl}/placeOrder/${id}`;
    public placeOrder(id: number): JQueryPromise<any> {
        return $.ajax(this.RoutePlaceOrder(id), {
            type: 'put',
            contentType: 'application/json'
        });
    }

    public RouteApprove = () => `${this.baseUrl}/approve`;
    public approve(model: ApproveOrderModel): JQueryPromise<any> {
        return $.ajax(this.RouteApprove(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEditPrice = () => `${this.baseUrl}/editPrice`;
    public editPrice(model: EditOrderModel): JQueryPromise<any> {
        return $.ajax(this.RouteEditPrice(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEditProduct = (id: number) => `${this.baseUrl}/editProduct/${id}`;
    public editProduct(id: number, model: EditProductModel): JQueryPromise<any> {
        return $.ajax(this.RouteEditProduct(id), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteChangeWebiste = () => `${this.baseUrl}/changeWebsite`;
    public changeWebiste(model: ChangeWebsiteOrderModel): JQueryPromise<any> {
        return $.ajax(this.RouteChangeWebiste(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteChangeWarehouse = (id: number, newWarehouseId: number) =>
        `${this.baseUrl}/changeWarehouse/${id}?newWarehouseId=${newWarehouseId}`;

    public changeWarehouse(id: number, newWarehouseId: number): JQueryPromise<any> {
        return $.ajax(this.RouteChangeWarehouse(id, newWarehouseId), {
            type: 'put',
            contentType: 'application/json'
        });
    }

    public RouteUnassignWarehouse = (id: number) => `${this.baseUrl}/unassignWarehouse/${id}`;
    public unassignWarehouse(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteUnassignWarehouse(id), {
            type: 'put',
            contentType: 'application/json'
        });
    }

    public RouteCreatePicture = (id: number) => `${this.baseUrl}/createPicture/${id}`;
}